import { AcornsIcon } from '@acorns/icons'
import { PillNavigation } from '@acorns/web-components'
import styled from 'styled-components'

import Layout from 'components/Layout'
import { Container, ContentCard } from 'components/Layout/Layout'
import { borderStyle } from 'components/Nav/FullNav/FullNav'
import theme from 'theme'

export const StyledLayout = styled(Layout)`
  ${Container} {
    padding-left: 0;
    padding-right: 0;
  }

  ${ContentCard} {
    padding: 0;

    @media (min-width: ${theme.breakpoints.sm + 1}px) {
      padding: 50px 0 30px;
    }
  }
`

export const PillNavContainer = styled.div<{ hasBorder: boolean }>`
  background-color: ${theme.colors.white};
  padding: 0 30px 10px;
  position: sticky;
  top: 66px;
  z-index: 1;
  ${props => borderStyle(props.hasBorder)}
  
  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    position: unset;
    padding: unset;
    padding-bottom: 30px;
  }
`

export const StyledPillNavigation = styled(PillNavigation)`
  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    max-width: 340px;
    margin: 0 auto;
  }
`

export const TierOption = styled.div<{ hidden: boolean; height: number }>`
  ${props => props.hidden && 'visibility: hidden;'}
  
  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    overflow-y: auto;
    height: calc(100vh - (${props => props.height}px + 335px));
    min-height: 300px;
  }
`

export const Header = styled.div<{ bgImageUrl: string }>`
  margin-top: 30px;
  padding: 0 30px 30px;
  background-image: url(${props => props.bgImageUrl});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: contain;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    padding-bottom: 50px;
  }
`

export const HeaderContent = styled.div`
  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    max-width: 340px;
    margin: 0 auto;
  }
`

export const Name = styled.p`
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: ${theme.colors.slate};
  margin-bottom: 0;
`

export const Price = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: ${theme.colors.green};
  margin: 0;
`

export const TierDescription = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${theme.colors.slate};
  max-width: 245px;
  margin-bottom: 0;
`

export const Divider = styled.div`
  background-color: ${theme.colors.ivoryLight};
  height: 10px;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    height: 1px;
    width: 100%;
  }
`

export const BenefitsContainer = styled.div`
  padding: 20px 30px;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    max-width: 340px;
    margin: 0 auto;
    padding: 0 0 50px;
  }
`

export const BundleContainer = styled.div`
  margin: 20px 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 40px;
  }

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    &:first-child {
      margin-top: 40px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const BundleHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`

export const BundleName = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: ${theme.colors.slate};
  margin: 0 0 0 12px;
  display: inline-block;
`

export const BundleProductContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
`

export const StyledIcon = styled(AcornsIcon)<{ isEnabled: boolean }>`
  margin: 5px;
  ${props =>
    !props.isEnabled &&
    `margin: 6px;
    path {
      &[fill] {
        fill: ${theme.colors.stoneLight};
      }
    }`}
`

export const BundleProductDescription = styled.p<{ isEnabled: boolean }>`
  font-size: 14px;
  line-height: 22px;
  color: ${props => (props.isEnabled ? theme.colors.slate : theme.colors.stone)};
  display: inline-block;
  margin: 0 0 0 5px;
`

export const ButtonContainer = styled.div`
  background-color: ${theme.colors.white};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 30px;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    position: unset;
    border-top: 1px solid ${theme.colors.ivory};
    padding-top: 30px;
    padding-bottom: 0px;
  }
`
